import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptBR from './locales/pt-BR.json';
import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'pt-BR',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'sola-language',
    },
  });

export default i18n;

export const LANGUAGES = [
  { code: 'pt-BR', label: 'Português' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
] as const;

/**
 * The DB stores short codes ('pt' | 'en' | 'es').
 * The i18n runtime uses BCP47-ish codes ('pt-BR' | 'en' | 'es').
 * Use these helpers everywhere we cross the boundary.
 */
export type DbLanguage = 'pt' | 'en' | 'es';

export const dbToI18n = (lang?: string | null): string => {
  if (lang === 'en') return 'en';
  if (lang === 'es') return 'es';
  return 'pt-BR';
};

export const i18nToDb = (lang?: string | null): DbLanguage => {
  if (!lang) return 'pt';
  if (lang.startsWith('en')) return 'en';
  if (lang.startsWith('es')) return 'es';
  return 'pt';
};

/** Human label for a DB language code (used in signup, profile, etc.) */
export const LANGUAGE_OPTIONS: { code: DbLanguage; label: string; short: string }[] = [
  { code: 'pt', label: 'Português', short: 'PT' },
  { code: 'en', label: 'English',   short: 'EN' },
  { code: 'es', label: 'Español',   short: 'ES' },
];
